// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"323bdb95","251":"838d25d6","548":"f87dd680","594":"3d088285","922":"abdfcdad"}[chunkId] + ".chunk.css";
};